import type { SVGProps } from "react";

const SvgRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.337 15.556c-3.072-.416-5.216-3.248-4.8-6.32a5.596 5.596 0 0 1 6.32-4.784c1.057.144 2 .576 2.768 1.2l-2.207 1.904 6.064 1.472-.288-6.4-2.048 1.744a7.481 7.481 0 0 0-4.016-1.856c-4.128-.576-7.952 2.32-8.528 6.448-.576 4.128 2.32 7.968 6.464 8.528 2.864.4 5.568-.864 7.168-3.056l-1.552-1.2a5.567 5.567 0 0 1-5.344 2.32Z" />
  </svg>
);
export default SvgRefresh;
